import * as Yup from "yup";

export const notificationSchema = Yup.object().shape({
  category: Yup.string().required("Category is required"),
  title: Yup.string().required("Title is required"),
  body: Yup.string().required("Message is required"),
  image: Yup.string(),
  linking: Yup.string().when("category", (category, schema) => {
    if (category == "Upcoming Events")
      return schema
        .url("Enter a valid URL")
        .required('Link is required when category is "Upcoming Events"');
    return schema;
  }),

  eventTitle: Yup.string().when("category", (category, schema) => {
    if (category == "Important Dates") {
      return schema.required("Event title is required");
    }
    return schema;
  }),

  startDate: Yup.string().when("category", {
    is: "Important Dates",
    then: (schema) =>
      schema
        .required("Start date and time are required")
        .test(
          "is-future-date",
          "Start date and time must be in the future",
          (value) => {
            return value && new Date(value) > new Date();
          },
        ),
    otherwise: (schema) => schema,
  }),

  endDate: Yup.string().when(["category", "startDate"], {
    is: (category, startDate) => category === "Important Dates",
    then: (schema) =>
      schema
        .required("End date and time are required")
        .test(
          "is-after-start",
          "End date cannot be before start date",
          function (value) {
            const { startDate } = this.parent;
            return value && startDate && new Date(value) > new Date(startDate);
          },
        ),
    otherwise: (schema) => schema,
  }),

  email: Yup.string().optional("Email is required"),
  gmoId: Yup.string().optional("GMO ID is required"),
  role: Yup.string().required("Please select a Role"),
  screen: Yup.string().optional(),
  itemId: Yup.string().optional(),
  documentTitle: Yup.string().optional(),
  documentUrl: Yup.string().optional(),
});
